import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ReactQuill from 'react-quill'
import { debounce } from 'lodash'
import S3FileUpload from 'react-s3/lib/ReactS3'
import dayjs from 'dayjs'

import {
    Col,
    Empty,
    Form,
    Input,
    InputNumber,
    Row,
    Select,
    message,
    Typography,
    Spin,
    Card,
    Tag,
    Switch,
    Radio,
    Divider,
    Space,
    theme,
    Tooltip,
} from 'antd'
import Dragger from 'antd/es/upload/Dragger'
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons'

// helpers
import useGooglePlace from '../../../helpers/googlePlacesFunction'

// constants
import {
    BUDGET_TYPE_OPTIONS,
    JOB_COMPANY_INDUSTRY,
    JOB_EXPERIENCE,
    JOB_STATUS_OPTIONS,
    jobRules,
} from '../../../constants/jobs'
import { MASTER_DATA_FIELD } from '../../../constants/masterData'

// assets
import { CrossIcon } from '../../../assets/icons'

// store
import { loginState } from '../../login/login.slice'
import { apiJobCreate, apiJobUpdate } from '../store/job.service'
import {
    changeModel,
    getJobDetails,
    getListJobs,
    jobState,
    masterDataAddDropDown,
    masterDataDropDownList,
    switchJobModal,
} from '../store/job.slice'

// components
import Button from '../../../components/button/button'
import DropDownMultiple from '../../../components/dropDownMultiple'
// import {
//     cleanObject,
//     removeExistingData,
// } from '../../../helpers/removeEmptyObjectValue'

import './index.css'
import styles from './AddEditJob.module.css'

const { Option } = Select
const { Text } = Typography

const WORKPLACE_OPTIONS = [
    {
        value: 'On-site',
        label: 'On-site',
        description: 'Employees work from an office',
    },
    {
        value: 'Hybrid',
        label: 'Hybrid',
        description: 'Employees work from both office and home',
    },
    {
        value: 'Remote',
        label: 'Remote',
        description: 'Employees work from home',
    },
]

const AddEditJobForm = () => {
    const [addEditJobAntdForm] = Form.useForm()

    const desc = Form.useWatch('description', addEditJobAntdForm) || ''
    const req = Form.useWatch('requirements', addEditJobAntdForm) || ''
    const ben = Form.useWatch('benefits', addEditJobAntdForm) || ''

    const stripHtml = (str) =>
        str
            .replace(/<[^>]*>/g, '')
            .replace(/&nbsp;/g, ' ')
            .trim()

    const totalLength =
        stripHtml(desc).length + stripHtml(req).length + stripHtml(ben).length

    const dispatch = useDispatch()

    const {
        modelType,
        masterDataDropDown,
        masterDataDropDownStatus,
        modalVariations,
        pageLimit,
        search,
        filter,
        jobDetails,
    } = useSelector(jobState)
    const { userProfile } = useSelector(loginState)

    const { useToken } = theme

    const { token } = useToken()

    // For Google Place API
    const [inputValue, setInputValue] = useState('')
    const [places, setPlaces] = useState([])
    const [searchValue, setSearchValue] = useState('')
    const [skillsData, setSkillsData] = useState([])
    const [fileURL, setFileURL] = useState([])
    const [isActive, setIsActive] = useState(false)

    // For Google Plce API
    useGooglePlace(inputValue, setPlaces)

    // For Budget Type
    const selectAfterBudget = (formName) => (
        <Form.Item name={formName} noStyle>
            <Select
                placeholder="Type"
                className={styles.budgetTypeSelect}
                popupMatchSelectWidth={false}
            >
                {BUDGET_TYPE_OPTIONS &&
                    BUDGET_TYPE_OPTIONS.map((type) => (
                        <Option key={type.value} value={type.value}>
                            {type.label}
                        </Option>
                    ))}
            </Select>
        </Form.Item>
    )

    // SEARCH MASTER DATA
    const searchFn = debounce((value, model) => {
        if (value?.length > 0) {
            dispatch(changeModel(model))
            dispatch(
                masterDataDropDownList({
                    search: value,
                    id: model,
                })
            )
        }
        setSearchValue(value)
    }, 800)

    // ADD MASTER DATA
    async function addMasterData() {
        const result = dispatch(
            masterDataAddDropDown({
                addData: {
                    type: 'manual',
                    data: {
                        name: searchValue,
                        logo:
                            modelType === 'tools'
                                ? 'https://pms-bucket123.s3.amazonaws.com/Layer_1_1689237094.svg'
                                : modelType === 'institute'
                                ? 'https://pms-bucket123.s3.amazonaws.com/Group 35301_1689226177.svg'
                                : '',
                        createdBy: userProfile?._id,
                    },
                },
                model: modelType,
            })
        )
        const data = result?.payload?.data

        if (data) {
            const { success, message: errorMessage } = data
            if (success) {
                dispatch(
                    masterDataDropDownList({
                        search: searchValue,
                        id: modelType,
                    })
                )
            } else {
                if (errorMessage) {
                    message.error(errorMessage)
                } else {
                    message.error('Something went wrong, try again later.')
                }
            }
        }
    }

    // ONCHANGE FILE PROPS
    const props = {
        name: 'fileLink',
        multiple: false,
        onChange(info) {
            // setStream(true)

            const nameChange = info?.fileList[0]?.name
                .split('.')[0]
                .concat(`_${dayjs(new Date()).unix()}`)
                .concat(`.${info?.fileList[0]?.name.split('.')[1]}`)

            const newFileData = new File(
                [info?.fileList[0]?.originFileObj],
                nameChange,
                { type: info?.fileList[0]?.type }
            )
            window.Buffer = window.Buffer || require('buffer').Buffer

            S3FileUpload.uploadFile(newFileData, userProfile?.s3Config)
                .then(async (data) => {
                    // fileUpload.push(data?.location)
                    setFileURL([data?.location])
                })
                .catch(() => {
                    message.error('Upload Failed!. Please Upload again')
                })
        },

        beforeUpload() {
            return false
        },

        onDrop() {},
    }

    const onFinishJob = async (values) => {
        dispatch(
            switchJobModal({
                ...modalVariations,
                saveButtonLoading: true,
            })
        )

        const finaleValues = values

        try {
            const data = {
                title: finaleValues?.title,
                location: finaleValues?.location,
                status: finaleValues?.status,
                noOfPositions: finaleValues?.numberOfPosition,
                budgetFrom: {
                    fromType: finaleValues?.budgetFromType,
                    fromValue: finaleValues?.budgetFrom,
                },
                budgetTo: {
                    toType: finaleValues?.budgetToType,
                    toValue: finaleValues?.budgetTo,
                },
                skills:
                    skillsData?.length > 0
                        ? skillsData.map((skill) => skill?.value)
                        : [],
                files: fileURL,
                description: finaleValues?.description,
                benefits: finaleValues?.benefits,
                requirements: finaleValues?.requirements,
                companyIndustry: finaleValues?.companyIndustry,
                workplace: finaleValues?.workplace,
                jobFunction:
                    typeof finaleValues?.jobFunction === 'object'
                        ? finaleValues?.jobFunction[0]?.value
                        : finaleValues?.jobFunction,
                employmentDetail: {
                    employmentType:
                        typeof finaleValues?.employmentType === 'object'
                            ? finaleValues?.employmentType[0]?.value
                            : finaleValues?.employmentType,
                    education:
                        typeof finaleValues?.education === 'object'
                            ? finaleValues?.education[0]?.value
                            : finaleValues?.education,
                    experience: finaleValues?.experience,
                },
            }

            let response = null

            if (modalVariations?.isEdit) {
                // let finalData = removeExistingData(jobDetails, data)

                const payload = {
                    updatedData: data,
                    _id: modalVariations?.selectedJobID,
                }

                response = await apiJobUpdate(payload)
            } else {
                response = await apiJobCreate(data)
            }

            if (response?.data?.success) {
                setFileURL([])
                setSkillsData([])
                message.success(response?.data?.message)
                addEditJobAntdForm.resetFields()
                dispatch(
                    getListJobs({
                        limit: pageLimit,
                        skip: 0,
                        search: search,
                        filter: { ...filter },
                    })
                )
            } else {
                message.error(response?.data?.message)
            }
        } catch (error) {
            console.log('error ====>', error)
        } finally {
            dispatch(
                switchJobModal({
                    ...modalVariations,
                    saveButtonLoading: false,
                    open: false,
                })
            )
        }
    }

    // GET JOB DETAILS
    useEffect(() => {
        if (modalVariations?.isEdit) {
            dispatch(getJobDetails(modalVariations?.selectedJobID))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalVariations?.isEdit])

    // EDIT JOB
    useEffect(() => {
        if (modalVariations?.isEdit && jobDetails) {
            addEditJobAntdForm.setFieldsValue({
                title: jobDetails?.title,
                jobCode: jobDetails?.jobCode,
                location: jobDetails?.location,
                status: jobDetails?.status,
                numberOfPosition: jobDetails?.noOfPositions,
                budgetFrom: jobDetails?.budgetFrom?.fromValue,
                budgetFromType: jobDetails?.budgetFrom?.fromType,
                budgetTo: jobDetails?.budgetTo?.toValue,
                budgetToType: jobDetails?.budgetTo?.toType,
                description: jobDetails?.description,
                requirements: jobDetails?.requirements,
                benefits: jobDetails?.benefits,
                companyIndustry: jobDetails?.companyIndustry,
                experience: jobDetails?.employmentDetail?.experience,
                workplace: jobDetails?.workplace,
                jobFunction: jobDetails?.jobFunction
                    ? [
                          {
                              label: jobDetails?.jobFunction?.name,
                              value: jobDetails?.jobFunction?._id,
                          },
                      ]
                    : [],
                employmentType: jobDetails?.employmentDetail?.employmentType
                    ? [
                          {
                              label: jobDetails?.employmentDetail
                                  ?.employmentType?.name,
                              value: jobDetails?.employmentDetail
                                  ?.employmentType?._id,
                          },
                      ]
                    : [],
                education: jobDetails?.employmentDetail?.education
                    ? [
                          {
                              label: jobDetails?.employmentDetail?.education
                                  ?.name,
                              value: jobDetails?.employmentDetail?.education
                                  ?._id,
                          },
                      ]
                    : [],
            })

            if (jobDetails?.skills?.length > 0) {
                setSkillsData(
                    jobDetails?.skills?.map((skill) => {
                        return {
                            label: skill?.name,
                            value: skill?._id,
                        }
                    })
                )
            }

            if (jobDetails?.files?.length > 0) {
                setFileURL(jobDetails?.files)
            }

            setIsActive(jobDetails?.isActiveJob)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jobDetails])

    if (!jobDetails && modalVariations?.isEdit) {
        return (
            <div
                style={{
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Spin />
            </div>
        )
    }

    return (
        <>
            {modalVariations?.isEdit && (
                <div className={styles.activeRow}>
                    <span>Active</span>
                    <Switch
                        value={isActive}
                        onChange={(checked) => {
                            setIsActive(checked)
                        }}
                    />
                </div>
            )}

            <div>
                <Form
                    className={styles.jobForm}
                    layout="vertical"
                    name="addEditJobAntdForm"
                    id="addEditJobAntdForm"
                    onFinish={onFinishJob}
                    requiredMark={false}
                    form={addEditJobAntdForm}
                    style={{
                        marginBottom: 0,
                        overflowX: 'hidden',
                    }}
                    initialValues={{
                        workplace: 'On-site',
                    }}
                >
                    <Row gutter={[12, 0]}>
                        <Col span={24}>
                            <Form.Item
                                name="title"
                                label="Job Title"
                                rules={jobRules.title}
                            >
                                <Input placeholder="Job Title" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="jobCode" label="Job Code">
                                <Input placeholder="Job Code" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Workplace"
                                name="workplace"
                                rules={jobRules.workplace}
                            >
                                <Radio.Group
                                    optionType="button"
                                    buttonStyle="solid"
                                    className={styles.workplaceGroup}
                                >
                                    {WORKPLACE_OPTIONS.map((option) => (
                                        <Radio.Button
                                            key={option.value}
                                            value={option.value}
                                            className={styles.workplaceButton}
                                        >
                                            <span
                                                className={
                                                    styles.workplaceButtonInner
                                                }
                                            >
                                                {option.label}
                                                <Tooltip
                                                    title={option.description}
                                                >
                                                    <InfoCircleOutlined
                                                        className={
                                                            styles.workplaceInfo
                                                        }
                                                        onClick={(event) => {
                                                            event.preventDefault()
                                                            event.stopPropagation()
                                                        }}
                                                    />
                                                </Tooltip>
                                            </span>
                                        </Radio.Button>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="Office location"
                                name="location"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter office location',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Search a Location"
                                    allowClear={false}
                                    notFoundContent={
                                        <Empty
                                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                                            description="No Locations Searched"
                                        ></Empty>
                                    }
                                    onSearch={(value) => {
                                        setInputValue(value)
                                    }}
                                    showSearch
                                    options={places}
                                    getPopupContainer={(trigger) =>
                                        trigger.parentNode
                                    }
                                    rootClassName="select-search-job"
                                />
                            </Form.Item>
                            <div className={styles.helperText}>
                                For best results, write a ZIP/postal code to
                                tell candidates where the office is based and to
                                effectively advertise this job.
                            </div>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                name="numberOfPosition"
                                label="Number Of Position"
                            >
                                <InputNumber
                                    min={0}
                                    controls={false}
                                    placeholder="Number Of Position"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item name="status" label="Status">
                                <Select
                                    placeholder="Status"
                                    options={JOB_STATUS_OPTIONS}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item name="budgetFrom" label="Budget From">
                                <div className={styles.budgetInput}>
                                    <Input
                                        placeholder="Budget From"
                                        addonAfter={selectAfterBudget(
                                            'budgetFromType'
                                        )}
                                    />
                                </div>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item name="budgetTo" label="Budget To">
                                <div className={styles.budgetInput}>
                                    <Input
                                        placeholder="Budget To"
                                        addonAfter={selectAfterBudget(
                                            'budgetToType'
                                        )}
                                    />
                                </div>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Select
                                placeholder="Search Skills"
                                showSearch
                                onSearch={(value) => {
                                    searchFn(value, MASTER_DATA_FIELD.skills)
                                }}
                                tagRender={() => null}
                                onSelect={(e, options) => {
                                    const trimSkills = options?.key.trimStart()
                                    if (trimSkills?.length > 0) {
                                        setSkillsData([
                                            ...skillsData,
                                            { label: trimSkills, value: e },
                                        ])
                                    }
                                }}
                                getPopupContainer={(trigger) =>
                                    trigger.parentNode
                                }
                                onDeselect={(e) => {
                                    const removeData = [...skillsData]
                                    removeData.splice(
                                        removeData.findIndex(
                                            (item) => item.label === e
                                        ),
                                        1
                                    )
                                    setSkillsData(removeData)
                                }}
                                style={{
                                    width: '100%',
                                }}
                                mode="multiple"
                                rootClassName={[
                                    'p-0-multiSelect',
                                    skillsData?.length > 0
                                        ? 'p-0-multiselect-setMargin'
                                        : '',
                                ]}
                                filterOption={false}
                                allowClear={false}
                                dropdownRender={(menu) => (
                                    <DropDownMultiple
                                        menu={menu}
                                        searchValue={searchValue}
                                        name={MASTER_DATA_FIELD.skills}
                                        addMasterData={() => addMasterData()}
                                    />
                                )}
                            >
                                {masterDataDropDown?.skills?.length > 0 &&
                                masterDataDropDownStatus === 'loaded'
                                    ? masterDataDropDown?.skills.map(
                                          (option) => {
                                              return (
                                                  <Option
                                                      key={option?.label}
                                                      value={option?.value}
                                                  >
                                                      <Text>
                                                          {option?.label}
                                                      </Text>
                                                  </Option>
                                              )
                                          }
                                      )
                                    : masterDataDropDownStatus ===
                                          'loading' && <Spin></Spin>}
                            </Select>
                            <div className={styles.skillsBlock}>
                                <span className={styles.skillsLabel}>
                                    Skills
                                </span>
                                <div className={styles.skillsBox}>
                                    <Row style={{ rowGap: '8px' }}>
                                        {skillsData?.length > 0 &&
                                            skillsData.map((skill, index) => (
                                                <Tag
                                                    className={styles.skillTag}
                                                    style={{
                                                        whiteSpace: 'normal',
                                                        overflow: 'hidden',
                                                    }}
                                                >
                                                    <Row
                                                        align={'middle'}
                                                        style={{
                                                            columnGap: '30px',
                                                        }}
                                                    >
                                                        <Text>
                                                            {skill?.label?.toUpperCase()}
                                                        </Text>
                                                        <div
                                                            style={{
                                                                width: '13px',
                                                            }}
                                                            onClick={() => {
                                                                searchFn(
                                                                    '',
                                                                    MASTER_DATA_FIELD.skills
                                                                )
                                                                const removeData =
                                                                    [
                                                                        ...skillsData,
                                                                    ]
                                                                removeData.splice(
                                                                    index,
                                                                    1
                                                                )
                                                                setSkillsData(
                                                                    removeData
                                                                )
                                                            }}
                                                        >
                                                            <CrossIcon
                                                                width="13"
                                                                color="#4338CA"
                                                            />
                                                        </div>
                                                    </Row>
                                                </Tag>
                                            ))}
                                    </Row>
                                </div>
                            </div>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                name="description"
                                label="About the role"
                                className="quill-form-job"
                            >
                                <div className="quill-container">
                                    <div>
                                        <h6>Description</h6>
                                        <Form.Item
                                            name="description"
                                            noStyle
                                            valuePropName="value"
                                            getValueFromEvent={(content) =>
                                                content
                                            }
                                            rules={[
                                                {
                                                    validator: () => {
                                                        if (totalLength < 700) {
                                                            return Promise.reject(
                                                                new Error(
                                                                    `Minimum 700 characters required.`
                                                                )
                                                            )
                                                        }
                                                        return Promise.resolve()
                                                    },
                                                },
                                            ]}
                                        >
                                            <ReactQuill
                                                theme="snow"
                                                style={{
                                                    borderRadius: '10px',
                                                    margin: '0 0 12px',
                                                }}
                                                className="job-quill-design"
                                                placeholder="Enter the job description here; include key areas of responsibility and what the candidate might do on a typical day."
                                                modules={{
                                                    toolbar: [
                                                        [
                                                            {
                                                                list: 'ordered',
                                                            },
                                                            {
                                                                list: 'bullet',
                                                            },
                                                        ],
                                                        [
                                                            {
                                                                header: [
                                                                    1,
                                                                    2,
                                                                    false,
                                                                ],
                                                            },
                                                        ],
                                                        [
                                                            'bold',
                                                            'italic',
                                                            'underline',
                                                            'strike',
                                                            'blockquote',
                                                        ],
                                                        ['link'],
                                                        [
                                                            {
                                                                indent: '-1',
                                                            },
                                                            {
                                                                indent: '+1',
                                                            },
                                                        ],
                                                        [{ align: [] }],
                                                        ['clean'],
                                                    ],
                                                }}
                                                formats={[
                                                    'list',
                                                    'bullet',
                                                    'indent',
                                                    'header',
                                                    'bold',
                                                    'italic',
                                                    'underline',
                                                    'strike',
                                                    'blockquote',
                                                    'link',
                                                ]}
                                            />
                                        </Form.Item>
                                    </div>

                                    <div>
                                        <h6>Requirements</h6>
                                        <Form.Item
                                            name="requirements"
                                            noStyle
                                            valuePropName="value"
                                            getValueFromEvent={(content) =>
                                                content
                                            } // Quill returns HTML string directly
                                        >
                                            <ReactQuill
                                                theme="snow"
                                                style={{
                                                    borderRadius: '10px',
                                                    margin: '0 0 12px',
                                                }}
                                                className="job-quill-design"
                                                placeholder="Enter the job requirements here; from soft skills to the specific qualifications needed to perform the role."
                                                modules={{
                                                    toolbar: [
                                                        [
                                                            {
                                                                list: 'ordered',
                                                            },
                                                            {
                                                                list: 'bullet',
                                                            },
                                                        ],
                                                        [
                                                            {
                                                                header: [
                                                                    1,
                                                                    2,
                                                                    false,
                                                                ],
                                                            },
                                                        ],
                                                        [
                                                            'bold',
                                                            'italic',
                                                            'underline',
                                                            'strike',
                                                            'blockquote',
                                                        ],
                                                        ['link'],
                                                        [
                                                            {
                                                                indent: '-1',
                                                            },
                                                            {
                                                                indent: '+1',
                                                            },
                                                        ],
                                                        [{ align: [] }],
                                                        ['clean'],
                                                    ],
                                                }}
                                                formats={[
                                                    'list',
                                                    'bullet',
                                                    'indent',
                                                    'header',
                                                    'bold',
                                                    'italic',
                                                    'underline',
                                                    'strike',
                                                    'blockquote',
                                                    'link',
                                                ]}
                                            />
                                        </Form.Item>
                                    </div>

                                    <div>
                                        <h6>Benefits</h6>
                                        <Form.Item
                                            name="benefits"
                                            noStyle
                                            valuePropName="value"
                                            getValueFromEvent={(content) =>
                                                content
                                            } // Quill returns HTML string directly
                                        >
                                            <ReactQuill
                                                theme="snow"
                                                style={{
                                                    borderRadius: '10px',
                                                    margin: '0 0 12px',
                                                }}
                                                className="job-quill-design"
                                                placeholder="Enter the benefits here; include not just salary details but the perks that make your company unique."
                                                modules={{
                                                    toolbar: [
                                                        [
                                                            {
                                                                list: 'ordered',
                                                            },
                                                            {
                                                                list: 'bullet',
                                                            },
                                                        ],
                                                        [
                                                            {
                                                                header: [
                                                                    1,
                                                                    2,
                                                                    false,
                                                                ],
                                                            },
                                                        ],
                                                        [
                                                            'bold',
                                                            'italic',
                                                            'underline',
                                                            'strike',
                                                            'blockquote',
                                                        ],
                                                        ['link'],
                                                        [
                                                            {
                                                                indent: '-1',
                                                            },
                                                            {
                                                                indent: '+1',
                                                            },
                                                        ],
                                                        [{ align: [] }],
                                                        ['clean'],
                                                    ],
                                                }}
                                                formats={[
                                                    'list',
                                                    'bullet',
                                                    'indent',
                                                    'header',
                                                    'bold',
                                                    'italic',
                                                    'underline',
                                                    'strike',
                                                    'blockquote',
                                                    'link',
                                                ]}
                                            />
                                        </Form.Item>
                                        <div
                                            style={{
                                                marginTop: 8,
                                                fontWeight: '500',
                                                color:
                                                    totalLength < 700
                                                        ? 'red'
                                                        : 'green',
                                            }}
                                        >
                                            Total Characters: {totalLength} /
                                            700
                                        </div>
                                    </div>
                                </div>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <div className={styles.sectionTitle}>
                                Company industry and Job function
                            </div>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="companyIndustry"
                                label="Company Industry"
                            >
                                <Select
                                    placeholder="Select...."
                                    options={JOB_COMPANY_INDUSTRY}
                                    showSearch
                                    rootClassName="select-search-job"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="Job Function"
                                name="jobFunction"
                                colon={false}
                            >
                                <Select
                                    placeholder="Search a Job Function"
                                    showSearch
                                    onSearch={(value) => {
                                        searchFn(
                                            value,
                                            MASTER_DATA_FIELD.designation
                                        )
                                    }}
                                    filterOption={false}
                                    allowClear={false}
                                    rootClassName="select-search-job"
                                    dropdownRender={(menu) => (
                                        <>
                                            {menu}
                                            <Divider
                                                style={{
                                                    margin: '8px 0',
                                                }}
                                            />
                                            <Space
                                                style={{
                                                    padding: '0 8px 4px',
                                                }}
                                            >
                                                <Row
                                                    align={'middle'}
                                                    style={{
                                                        columnGap: '5px',
                                                        cursor:
                                                            searchValue?.length >
                                                            0
                                                                ? 'pointer'
                                                                : 'not-allowed',
                                                    }}
                                                    onClick={() => {
                                                        if (
                                                            searchValue?.length >
                                                            0
                                                        ) {
                                                            addMasterData()
                                                        }
                                                    }}
                                                >
                                                    <PlusOutlined
                                                        style={{
                                                            color: token
                                                                .colorPalette
                                                                .baseColor
                                                                .tertiary,
                                                            fontSize:
                                                                token.fontSizeHeading5,
                                                        }}
                                                    />
                                                    <Text
                                                        style={{
                                                            color: token
                                                                .colorPalette
                                                                .baseColor
                                                                .tertiary,
                                                            fontSize:
                                                                token.fontSizeHeading5,
                                                            fontWeight:
                                                                token.fontWeightStrong,
                                                        }}
                                                    >
                                                        Add
                                                    </Text>
                                                </Row>
                                            </Space>
                                        </>
                                    )}
                                >
                                    {masterDataDropDown?.designation?.length >
                                        0 &&
                                    masterDataDropDownStatus === 'loaded'
                                        ? masterDataDropDown?.designation.map(
                                              (option) => {
                                                  return (
                                                      <Option
                                                          key={option?.value}
                                                          value={option?.value}
                                                      >
                                                          <Text>
                                                              {option?.label}
                                                          </Text>
                                                      </Option>
                                                  )
                                              }
                                          )
                                        : masterDataDropDownStatus ===
                                              'loading' && <Spin></Spin>}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <div className={styles.sectionTitle}>
                                Employment Details
                            </div>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Employment Type"
                                name={MASTER_DATA_FIELD.employmentType}
                                colon={false}
                            >
                                <Select
                                    placeholder="Search an Employment Type"
                                    showSearch
                                    onSearch={(value) => {
                                        dispatch(
                                            changeModel(
                                                MASTER_DATA_FIELD.employmentType
                                            )
                                        )
                                        searchFn(
                                            value,
                                            MASTER_DATA_FIELD.employmentType
                                        )
                                    }}
                                    filterOption={false}
                                    allowClear={false}
                                    rootClassName="select-search-job"
                                    dropdownRender={(menu) => (
                                        <DropDownMultiple
                                            menu={menu}
                                            searchValue={searchValue}
                                            name={
                                                MASTER_DATA_FIELD.employmentType
                                            }
                                            addMasterData={() =>
                                                addMasterData()
                                            }
                                        />
                                    )}
                                    getPopupContainer={(trigger) =>
                                        trigger.parentNode
                                    }
                                >
                                    {masterDataDropDown?.employmentType
                                        ?.length > 0 &&
                                    masterDataDropDownStatus === 'loaded'
                                        ? masterDataDropDown?.employmentType.map(
                                              (option) => {
                                                  return (
                                                      <Option
                                                          key={option?.value}
                                                          value={option?.value}
                                                      >
                                                          <Text>
                                                              {option?.label}
                                                          </Text>
                                                      </Option>
                                                  )
                                              }
                                          )
                                        : masterDataDropDownStatus ===
                                              'loading' && <Spin></Spin>}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="experience" label="Experience">
                                <Select
                                    placeholder="Select...."
                                    options={JOB_EXPERIENCE}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="Education"
                                name={'education'}
                                colon={false}
                            >
                                <Select
                                    placeholder="Search an Education"
                                    showSearch
                                    onSearch={(value) => {
                                        searchFn(
                                            value,
                                            MASTER_DATA_FIELD.degree
                                        )
                                    }}
                                    filterOption={false}
                                    allowClear={false}
                                    rootClassName="select-search-job"
                                    dropdownRender={(menu) => (
                                        <DropDownMultiple
                                            menu={menu}
                                            searchValue={searchValue}
                                            name={MASTER_DATA_FIELD.degree}
                                            addMasterData={() =>
                                                addMasterData()
                                            }
                                        />
                                    )}
                                    getPopupContainer={(trigger) =>
                                        trigger.parentNode
                                    }
                                >
                                    {masterDataDropDown?.degree?.length > 0 &&
                                    masterDataDropDownStatus === 'loaded'
                                        ? masterDataDropDown?.degree.map(
                                              (option) => {
                                                  return (
                                                      <Option
                                                          key={option?.value}
                                                          value={option?.value}
                                                      >
                                                          <Text>
                                                              {option?.label}
                                                          </Text>
                                                      </Option>
                                                  )
                                              }
                                          )
                                        : masterDataDropDownStatus ===
                                              'loading' && <Spin></Spin>}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            {fileURL?.length > 0 ? (
                                <Card
                                    style={{
                                        minHeight: '185px',
                                        padding: 0,
                                        position: 'relative',
                                    }}
                                    styles={{
                                        body: {
                                            padding: 0,
                                        },
                                    }}
                                >
                                    {fileURL?.join(',')}
                                </Card>
                            ) : (
                                <Form.Item name="fileUpload">
                                    <Dragger
                                        {...props}
                                        fileList={[]}
                                        showUploadList={false}
                                        previewFile={false}
                                        className={styles.uploadDropzone}
                                        accept=".MP4,.MOV,.WMV,.AVI,.AVCHD,.FLV,.F4V,.SWF,.MKV,.WEBM,.HTML5,.PDF,.DOC,.DOCX,.PPT,.PPTX,.XLS,.XLSX,.TXT,.CSV,.RTF,.ODT,.ODS,.JPEG,.JPG,.PNG"
                                    >
                                        <Text className="titleSecondary">
                                            Click or Drag
                                        </Text>
                                        <br />
                                        <Text className="titleSecondary">
                                            File to Upload
                                        </Text>
                                    </Dragger>
                                </Form.Item>
                            )}

                            {fileURL?.length > 0 && (
                                <Button
                                    props={{
                                        text: 'Remove File',
                                        onClick: () => setFileURL([]),
                                        style: {
                                            width: '100%',
                                            marginTop: '25px',
                                        },
                                    }}
                                />
                            )}
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    )
}

export default AddEditJobForm
